module.exports = __webpack_public_path__ + "img/readonly.6e90978a.svg";